module.exports = __webpack_public_path__ + "static/img/comunidades.15239b8a.png";